/**
 * Determines if a customer is a CAP HEA customer.
 * CAP status only applies to the HEA path — HealthyHome customers are never CAP.
 */
const isCapHeaCustomer = (values) => {
  return values.path === 'hea' && values.paymentAssistance === 'yes'
}

export default isCapHeaCustomer
